import { Component, OnInit } from '@angular/core';
import { Product, ProductOrderLine, Cart } from '../../../libs/proto/shop_pb';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLibService } from '../../../service/user/user-lib.service';
import { GrpcProductLibService } from '../../../service/grpc/product/grpc-product-lib.service';
import { TranslateService } from '@ngx-translate/core';
import { Color } from '../../../libs/proto/commUnity_pb';
import { environment } from '../../../../environments/environment';
import { GrpcShopLibService } from '../../../service/grpc/shop/grpc-shop-lib.service';
import { DialogServiceService } from '../../../service/dialog/dialog-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageLibService } from '../../../service/storage/storage-lib.service';
import { CartConversionService } from '../../../service/conversion/cart/cart-conversion.service';
import { DeviceLibService } from 'src/app/service/device/device-lib.service';
import { desktopMode } from 'src/app/config/type';
import { buildVariantMatrix, ColorVariant, SizeStock, VariantInterface } from '../../product/product.component';
import { ColorConversionService } from 'src/app/service/conversion/color/color-conversion.service';

export interface OrderForm {
  size?: string;
  color?: string;
  qtySelect?: string;
  qtyEdit?: string;
  qtyOK?: string;
  show?: boolean;

  lValue?: ProductOrderLine;
  qElem?: HTMLSpanElement;
  tElem?: HTMLSpanElement;
}

@Component({
  selector: 'app-product-confirm',
  templateUrl: './product-confirm.component.html',
  styleUrls: ['./product-confirm.component.sass']
})
export class ProductConfirmComponent implements OnInit {
  imageObject: Array<object> = [];
  imageSize: object = { width: '100%' };

  order: ProductOrderLine;
  orderForm: OrderForm;
  product: Product;
  colors: {k?: string, v?: string} = {};
  colorL: {key: string, label: string}[] = [];
  /**
   * translations
   */
  T = {};
  landscapeEvt = window.matchMedia('(orientation: landscape)');
  isLandscape = false;

  menuType = 0;

  private prepareImage() {
    let imgc:string[] = [this.colorImages[this.orderForm.color || ''] || ''].filter( p => p.length > 0);
    (imgc.length > 0 ? imgc : ['assets/images/nophoto.png']).forEach( p => {
      this.imageObject.push(
        {
          image: p,
          thumbImage: p
        }
      );
    });
  }
  selectColor(color: string): void {
    this.orderForm.color = color;
    const active = this.colorVariants.find(c => c.label === this.orderForm.color);
    this.orderForm.size = active?.sizes[0].size;
    this.imageObject = [];
    this.prepareImage();
  }
  selectSize(size: string): void {
    this.orderForm.size = size;
  }

  get activeVariantSizes(): SizeStock[] {
    const active = this.colorVariants.find(c => c.label === this.orderForm.color);
    return active ? active.sizes : [];
  }

  colorVariants: ColorVariant[] = [];
  colorImages: {[key: string]: string} = {};
  prev_color: string = '';
  prev_size: string = '';

  constructor(
    private actRoute: ActivatedRoute,
    private userLib: UserLibService,
    private grpcProductLib: GrpcProductLibService,
    private grpcShopLib: GrpcShopLibService,
    private translate: TranslateService,
    private dlgLib: DialogServiceService,
    private snackbar: MatSnackBar,
    private route: Router,
    private storeLib: StorageLibService,
    private convLib: CartConversionService,
    private detector: DeviceLibService,
    private colorlib: ColorConversionService,
  ) { 
    let extradata = route.getCurrentNavigation()?.extras.state;
    if (extradata) {
      this.prev_color = extradata.color;
      this.prev_size = extradata.size;
    }
  }
  get currencysymbol() {
    return this.userLib.Data.token?.getCustomer().getCurrencysymbol();
  }
  ngOnInit(): void {
    const thise = this;
    this.actRoute.paramMap.subscribe( p => {
      thise.grpcProductLib.getProducts({
        Offline: true,
        call: {
          req: p.get('id'),
        }
      }).then( ns => {
        thise.product = ns[0];
        let p:VariantInterface = {
          product:thise.product,
          colorVariants: thise.colorVariants,
          colorImages: thise.colorImages,
          selectedColor: '',
          selectedSize: '',
          userlang: thise.userLib.Data.token?.getProfile()?.getLanguage().toString(),
          colorlib: thise.colorlib,
        }
        buildVariantMatrix(p);
        this.colorVariants = p.colorVariants;
        this.colorImages = p.colorImages;
        this.orderForm.color = thise.prev_color || p.selectedColor;
        this.orderForm.size = thise.prev_size || p.selectedSize;
        this.prepareImage();
      });
    });

    this.orderForm = {
      qtySelect: '1'
    };

    this.isLandscape = this.detector.orientation === 'landscape';
    this.menuType = this.getmenuType();
    this.landscapeEvt.addEventListener('change', ev => {
      this.isLandscape = this.landscapeEvt.matches;
      this.menuType = this.getmenuType();
    });
  }
  private loadColors(){
    // keep key
    const tLists: string[] = [];
    Object.keys(Color).map( c => {
      if (c !== 'COLOR_NO') {
        this.colors[Color[c]] = c;
        tLists.push('colors.' + c);
      }
    });

    const thise = this;
    // translate
    this.translate.get(tLists).toPromise().then( t => {
      thise.T = t;
      thise.colorL = thise.colorList(thise.product);
      if (thise.orderForm.color === undefined) {
        thise.orderForm.color = (thise.colorL || [{}])[0].key;
      }
    });

    if (thise.product) { thise.orderForm.size = (thise.product.getSizesList() || [''])[0]; }
    this.setOrder();
  }

  private setOrder() {
    this.order = new ProductOrderLine();
    this.order.setProductid( this.product.getId());
    this.order.setPhoto( (this.product.getImagesList() || [null])[0]);
    this.order.setProductname( this.product.getName());

    this.order.setQuantity( +this.orderQty );
    const colorKey = ('COLOR_' + this.orderForm.color) as keyof typeof Color;

    if (colorKey in Color) {
      const colorValue = Color[colorKey]; // Returns the numeric enum value
      this.order.setColor(colorValue);
    }
    this.order.setSize( this.orderForm.size );

    this.order.setTotalprice( +this.orderQty * this.product.getPrice());
  }

  get orderQty(): string {
    return this.orderForm.qtyOK || this.orderForm.qtySelect;
  }

  updateOrder() {
    if (this.orderForm.qtySelect === 'product-confirm.Other') {
      this.orderForm.qtyOK = undefined;
      this.orderForm.show = true;
      return;
    }

    this.orderForm.qtyOK = undefined;
    this.order.setQuantity( +this.orderQty);
  }
  get total(): number {
    return +this.orderQty * this.product?.getPrice();
  }

  get backgroundColor() {
    return this.userLib.designToolbarBackgroundColor;
  }
  get foregroundColor() {
    return this.userLib.designToolbarTextColor;
  }

  private colorList(p?: Product): {key: string, label: string}[] {
    return p?.getColorsList().map( v => (
      {key: v + '', label: this.T['colors.' + this.colors[v]] }
    ));
  }
  get diagnostic() {
    if (environment.production) { return; }
    return JSON.stringify(this.orderForm);
  }

  qtyClose() {
    this.orderForm.qtySelect = '1';
  }

  qtyOK() {
    this.orderForm.qtyOK = this.orderForm.qtyEdit;
  }

  addProductToCart() {
    const thise = this;
    this.setOrder();
    const selectedVariant = this.colorVariants.find(c => c.label === this.orderForm.color);
    const selectedSizeStock = selectedVariant?.sizes.find(s => s.size === this.orderForm.size);
    if (this.product.getQtyn()) {
      // check correct qty
      if (selectedSizeStock && this.order.getQuantity() > selectedSizeStock.qty) {

          this.translate.get([
            'shop.qty_over',
            'shop.title',
          ]).toPromise().then( t => {
            thise.dlgLib.show(t['shop.qty_over'].replace('%s', this.product.getQt()), t['shop.title']);
          });
          return;
      }
    }

    this.grpcShopLib.addProductToCart(this.order).then( c => {

      thise.keepCart(c);
      thise.addProductToCartOK();

    }).catch( e => {

      thise.addProductToCartError(e);
    });
  }
  private keepCart(c: Cart) {
    this.storeLib.set('cart-badge', c.getNbitems());
    this.storeLib.set('cart',
      this.convLib.ToStorage( c ));
  }
  private addProductToCartOK() {
    const thise = this;
    this.translate.get([
      'shop.add_to_cart_ok',
    ]).toPromise().then( t => {
      thise.snackbar.open(t['shop.add_to_cart_ok'], null, {
        duration: 1000
      }).afterDismissed().toPromise().then( d => {
        thise.route.navigateByUrl('/shop');
      });
    });
  }
  private addProductToCartError(e: Error) {
    const thise = this;
    this.translate.get([
      'shop.add_to_cart_failed',
      'shop.title'
    ]).toPromise().then( t => {
      thise.dlgLib.show(t['shop.add_to_cart_failed'],
                        t['shop.title'], r => {}, {
                          showTechnical: true,
                          technicalMessage: JSON.stringify(e)
                        });
    });
  }

  get product_qty() {
    if (this.product?.getQtyn()) {
       return this.product.getQt();
    }

    return '';
  }

    /**
   * menu type
   * - 0 = list
   * - 1 = box with image (2 cols)
   * - 2 = box with image (4 cols)
   */
    getmenuType() {
      // if not mobile, return default mobile
      if (!this.detector.isMobile()) {
        // if desktop mode = 3, force to use photo menu
        if (+desktopMode === 3) { return 1; }
        // if desktop mode = 4, force to use photo menu4
        if (+desktopMode === 4)  {
          if (this.isLandscape) { return 2;  }
          return 1;
        }
  
        return 0;
      }
  
      return this.userLib.Data.token?.getCustomer()?.getMobilemenutype();
    }
  
}
